import Vue from 'vue'
import Router from 'vue-router'
const layout = resolve => require(['@/views/layout.vue'], resolve)
const main = resolve => require(['@/views/main.vue'], resolve)
const login = resolve => require(['@/views/login.vue'], resolve)

Vue.use(Router)

const routes = [{
  path: '/login',
  name: 'login',
  component: login,
  hidden: true
},
{
  path: '*',
  redirect: 'layout',
  hidden: true
},

{
  path: '/',
  // name: '货源与车源',
  component: layout,
  hidden: false,
  children: [{
    path: '/',
    // name: '初级货源',
    redirect: '/manage/lowsource',
    hidden: true
  },
  {
    path: '/manage',
    // name: '货源与车源',
    component: main,
    hidden: false,
    children: [{
      path: '/',
      // name: '初级货源',
      redirect: 'lowsource',
      hidden: true
    },
    {
      path: 'lowsource',
      name: '初级货源',
      component: resolve =>
        require(['@/views/manage/source/lowSource.vue'], resolve),
      hidden: false
    },
    {
      path: 'heightSource',
      name: '高级货源',
      component: resolve =>
        require(['@/views/manage/source/heightSource.vue'], resolve),
      hidden: false
    },
    {
      path: 'matchingInfo',
      name: '匹配车辆',
      component: resolve =>
        require(['@/views/manage/source/matchingInfo.vue'], resolve),
      hidden: true
    },
    {
      path: 'private',
      name: '专线招标货源',
      component: resolve =>
        require(['@/views/manage/source/private.vue'], resolve),
      hidden: false
    },
    {
      path: 'enquiry',
      name: '询价货源',
      component: resolve =>
        require(['@/views/manage/source/enquiry.vue'], resolve),
      hidden: false
    },
    {
      path: 'shareCar',
      name: '初级车源',
      component: resolve =>
        require(['@/views/manage/source/shareCar.vue'], resolve),
      hidden: false
    },
    {
      path: 'recommend',
      // name: '',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        // name: '返程推荐',
        component: resolve =>
          require([
            '@/views/manage/source/recommend/recommend.vue'
          ], resolve),
        hidden: false
      },
      {
        path: 'proposedRoute',
        // name: '返程推荐线路(待推荐)',
        component: resolve =>
          require([
            '@/views/manage/source/recommend/proposedRoute.vue'
          ], resolve),
        hidden: false
      },
      {
        path: 'proposedRodeDetail',
        // name: '返程推荐线路',
        component: resolve =>
          require([
            '@/views/manage/source/recommend/proposedRodeDetail.vue'
          ], resolve),
        hidden: false
      },
      {
        path: 'recommendRoute',
        // name: '返程推荐线路',
        component: resolve =>
          require([
            '@/views/manage/source/recommend/recommendRoute.vue'
          ], resolve),
        hidden: false
      },
      {
        path: 'rodeDetail',
        // name: '返程推荐线路',
        component: resolve =>
          require([
            '@/views/manage/source/recommend/rodeDetail.vue'
          ], resolve),
        hidden: false
      },
      {
        path: 'waybillRecord',
        // name: '运单记录',
        component: resolve =>
          require([
            '@/views/manage/source/recommend/waybillRecord.vue'
          ], resolve),
        hidden: false
      }
      ]
    }
    ]
  },
  {
    path: '/manage',
    // name: '运单管理',
    component: main,
    hidden: false,
    children: [{
      path: 'heightWaybill',
      name: '高级货源运单',
      component: resolve =>
        require(['@/views/manage/waybill/heightWaybill.vue'], resolve),
      hidden: false
    },
    {
      path: 'waybillDetail',
      name: 'waybillDetail',
      component: resolve =>
        require(['@/views/manage/waybill/waybillDetail.vue'], resolve),
      hidden: true
    },
    {
      path: 'privateWaybill',
      // name: '专线招标运单',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        name: '专线招标运单',
        component: resolve =>
          require([
            '@/views/manage/waybill/privateWaybill.vue'
          ], resolve),
        hidden: false
      },
      {
        path: 'privateDetail',
        // name: '专线招标运单详情',
        component: resolve =>
          require([
            '@/views/manage/waybill/privateDetail.vue'
          ], resolve),
        hidden: false
      }
      ]
    }
    ]
  },
  {
    path: '/manage',
    // name: '工厂源管理',
    component: main,
    hidden: false,
    children: [{
      path: 'factory',
      // name: '工厂源管理',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        name: '工厂源管理',
        component: resolve =>
          require([
            '@/views/manage/service/factory/factory.vue'
          ], resolve),
        hidden: false
      },
      {
        path: 'addFactory',
        // name: '工厂源管理',
        component: resolve =>
          require([
            '@/views/manage/service/factory/addFactory.vue'
          ], resolve),
        hidden: false
      }
      ]
    },
    {
      path: 'chemical',
      // name: '危险品运输安全卡',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        // name: '危险品运输安全卡',
        component: resolve =>
          require([
            '@/views/manage/service/chemical/chemical.vue'
          ], resolve),
        hidden: false
      },
      {
        path: 'addChemical',
        // name: '添加运输卡',
        component: resolve =>
          require([
            '@/views/manage/service/chemical/addChemical.vue'
          ], resolve),
        hidden: false
      },
      {
        path: 'chemicalDetail',
        // name: '运输卡详情页',
        component: resolve =>
          require([
            '@/views/manage/service/chemical/chemicalDetail.vue'
          ], resolve),
        hidden: false
      }
      ]
    },
    {
      path: 'areas',
      name: '省市区管理',
      component: resolve =>
        require(['@/views/manage/service/areas/areas.vue'], resolve),
      hidden: false
    }
    ]
  },
  {
    path: '/manage',
    // name: '数据统计',
    component: main,
    hidden: false,
    children: [{
      path: 'resource',
      name: '资源定位分布',
      component: resolve =>
        require(['@/views/manage/statistics/resource.vue'], resolve),
      hidden: false
    },
    {
      path: 'carkit',
      name: '车载设备统计',
      component: resolve =>
        require(['@/views/manage/statistics/carkit.vue'], resolve),
      hidden: false
    },
    {
      path: 'company',
      name: '公司分类统计',
      component: resolve =>
        require(['@/views/manage/statistics/company.vue'], resolve),
      hidden: false
    }
    ]
  },
  {
    path: '/manage',
    // name: '用户信息管理',
    component: main,
    hidden: false,
    children: [{
      path: 'userlist',
      // name: '用户列表',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        component: resolve =>
          require(['@/views/manage/userinfo/userlist.vue'], resolve),
        hidden: true
      },
      {
        path: 'adduserlist',

        name: '添加、修改用户列表',
        component: resolve =>
          require(['@/components/userlist/AddUserList.vue'], resolve),
        hidden: true
      }
      ]
    },
    {
      path: 'companylist',
      // name: '公司列表',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        component: resolve =>
          require(['@/views/manage/userinfo/companylist.vue'], resolve),
        hidden: true
      },
      {
        path: 'auditEarnest',
        name: '信息审核',
        component: resolve =>
          require([
            '@/views/manage/userinfo/auditEarnest.vue'
          ], resolve),
        hidden: true
      },
      {
        path: 'operation',
        name: '运营路线',
        component: resolve =>
          require(['@/views/manage/userinfo/operation.vue'], resolve),
        hidden: true
      },
      {
        path: 'addCompany',
        name: '添加公司',
        component: resolve =>
          require(['@/views/manage/userinfo/addCompany.vue'], resolve),
        hidden: true
      },
      {
        path: 'authorizationAudit',
        name: '授权审核',
        component: resolve =>
          require([
            '@/views/manage/userinfo/authorizationAudit.vue'
          ], resolve),
        hidden: true
      }
      ]
    },
    {
      path: 'financial',
      // name: '公司列表',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        component: resolve =>
          require(['@/views/manage/userinfo/financial.vue'], resolve),
        hidden: true
      },

      {
        path: 'updateFinancial',
        name: '修改用户金融审核',
        component: resolve =>
          require(['@/views/manage/userinfo/updateFinancial.vue'], resolve),
        hidden: true
      }
      ]
    },

    {
      path: 'drivers',
      // name: '司机车辆信息',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        component: resolve =>
          require(['@/views/manage/userinfo/drivers.vue'], resolve),
        hidden: false
      },
      {
        path: 'updateDrivers',
        name: '修改司机车辆信息',
        component: resolve =>
          require(['@/components/drivers/UpdateDrivers.vue'], resolve),
        hidden: true
      }
      ]
    },
    {
      path: 'userinfo',
      name: '管理员信息',
      component: resolve =>
        require(['@/views/manage/userinfo/userInfo.vue'], resolve),
      hidden: false
    }
    ]
  },
  {
    path: '/manage',
    // name: '金融管理',
    component: main,
    hidden: false,
    children: [{
      path: 'bank',
      // name: '银行管理',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        component: resolve =>
          require(['@/views/manage/finance/bank.vue'], resolve),
        hidden: true
      },
      {
        path: 'addBank',
        name: '添加、修改银行',
        component: resolve =>
          require(['@/components/bank/AddBank.vue'], resolve),
        hidden: true
      }
      ]
    },
    {
      path: 'financialfirm',
      // name: '金融公司管理',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        name: '金融公司管理',
        component: resolve =>
          require([
            '@/views/manage/finance/financialfirm.vue'
          ], resolve),
        hidden: true
      },
      {
        path: 'addFinancialfirm',
        name: '添加金融公司管理',
        component: resolve =>
          require([
            '@/views/manage/finance/addFinancialfirm.vue'
          ], resolve),
        hidden: true
      }
      ]
    },
    {
      path: 'apply',
      // name: '金融申请',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        name: '金融申请',
        component: resolve =>
          require(['@/views/manage/finance/apply.vue'], resolve),
        hidden: true
      },
      {
        path: 'changeApply',
        name: '修改合同',
        component: resolve =>
          require(['@/views/manage/finance/changeApply.vue'], resolve),
        hidden: true
      }
      ]
    }
    ]
  },
  {
    path: '/manage',
    // name: '账单管理',
    component: main,
    hidden: false,
    children: [{
      path: 'tradeBill',
      // name: '交易账单',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        name: '账单交易',
        component: resolve =>
          require(['@/views/manage/tradeBill/tradeBill.vue'], resolve),
        hidden: true
      },
      {
        path: 'billingDetail',
        // name: '账单交易详情',
        component: resolve =>
          require([
            '@/views/manage/tradeBill/billingDetail.vue'
          ], resolve),
        hidden: true
      }
      ]
    }]
  },

  {
    path: '/manage',
    // name: '系统管理',
    component: main,
    hidden: false,
    children: [
      //   {
      //   path: 'email',
      //   name: '邮箱管理',
      //   component: resolve =>
      //     require(['@/views/manage/management/email.vue'], resolve),
      //   hidden: false
      //   // children: [{
      //   //   path: '/',
      //   //   component: resolve =>
      //   //     require(['@/views/manage/userinfo/companylist.vue'], resolve),
      //   //   hidden: true
      //   // }]
      // },
      {
        path: 'email',
        // name: '邮箱管理',
        component: main,
        hidden: false,
        children: [{
          path: '/',
          name: '邮箱管理',
          component: resolve =>
            require(['@/views/manage/management/email.vue'], resolve),
          hidden: true
        },
        {
          path: 'addEmail',
          name: '修改邮箱',
          component: resolve =>
            require(['@/components/email/AddEmail.vue'], resolve),
          hidden: true
        }
        ]
      },
      {
        path: 'banner',
        // name: 'banner管理',
        component: main,
        hidden: false,
        children: [{
          path: '/',
          component: resolve =>
            require(['@/views/manage/management/banner.vue'], resolve),
          hidden: true
        }, {
          path: 'addBanner',
          name: '添加、修改banner',
          component: resolve =>
            require(['@/components/banner/AddBanner.vue'], resolve),
          hidden: true
        }]
      },
      {
        path: 'share',
        // name: '分享管理',
        component: main,
        hidden: false,
        children: [{
          path: '/',
          component: resolve =>
            require(['@/views/manage/management/share.vue'], resolve),
          hidden: true
        },
        {
          path: 'addShare',
          name: '添加、修改share',
          component: resolve => require(['@/components/share/AddShare.vue'], resolve),
          hidden: true
        }
        ]
      },
      {
        path: 'version',
        // name: '版本管理',
        component: main,
        hidden: false,
        children: [{
          path: '/',
          component: resolve =>
            require(['@/views/manage/management/version.vue'], resolve),
          hidden: true
        },
        {
          path: 'addVersion',
          name: '添加、修改version',
          component: resolve => require(['@/components/version/AddVersion.vue'], resolve),
          hidden: true
        }
        ]
      },
      {
        path: 'message',
        // name: '消息管理',
        component: main,
        hidden: false,
        children: [{
          path: '/',
          component: resolve =>
            require(['@/views/manage/management/message.vue'], resolve),
          hidden: true
        },
        {
          path: 'addMessage',
          name: '添加、修改message',
          component: resolve => require(['@/components/message/AddMessage.vue'], resolve),
          hidden: true
        }
        ]
        // hidden: false
      },
      {
        path: 'feedback',
        name: '用户反馈',
        component: resolve =>
          require(['@/views/manage/management/feedback.vue'], resolve),
        hidden: false
      }
    ]
  },
  {
    path: '/system',
    // name: '系统设置',
    component: main,
    hidden: false,
    children: [{
      path: '/',
      // name: '组织结构',
      redirect: 'organiz',
      hidden: true
    },
    {
      path: 'organiz',
      // name: '组织结构',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        component: resolve =>
          require([
            '@/views/system/organization/organization.vue'
          ], resolve),
        hidden: true
      },
      {
        path: 'addOrganization',
        // name: '添加组织结构',
        component: resolve =>
          require(['@/views/system/organization/addOrg.vue'], resolve),
        hidden: true
      }
      ]
    },
    {
      path: 'role',
      // name: '角色管理',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        component: resolve =>
          require(['@/views/system/role/role.vue'], resolve),
        hidden: true
      },
      {
        path: 'addRole',
        name: '添加组织结构',
        component: resolve =>
          require(['@/views/system/role/addRole.vue'], resolve),
        hidden: true
      }
      ]
    },
    {
      path: 'administrator',
      // name: '管理员',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        component: resolve =>
          require([
            '@/views/system/administrator/administrator.vue'
          ], resolve),
        hidden: true
      },
      {
        path: 'addAdmin',
        // name: '添加组织结构',
        component: resolve =>
          require([
            '@/views/system/administrator/addAdmin.vue'
          ], resolve),
        hidden: true
      }
      ]
    },
    {
      path: 'menu',
      // name: '菜单管理',
      component: main,
      hidden: false,
      children: [{
        path: '/',
        component: resolve =>
          require(['@/views/system/menu/menu.vue'], resolve),
        hidden: true
      },
      {
        path: 'addMenu',
        // name: '添加组织结构',
        component: resolve =>
          require(['@/views/system/menu/addMenu.vue'], resolve),
        hidden: true
      }
      ]
    },
    {
      path: 'syslog',
      name: '系统日志',
      component: resolve =>
        require(['@/views/system/syslog.vue'], resolve),
      hidden: false
    }
    ]
  }
  ]
}
]
const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem('token')
  if (token) {
    if (to.path === '/login') {
      next('/')
    } else {
      next()
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
})
export default router
